<template>
  <v-fade-transition mode="out-in">
    <router-view/>
  </v-fade-transition>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  data: () => ({
    routes: [
      {
        to: "/staff",
        text: "Placements"
      }
    ]
  }),
  methods: {
    ...mapMutations(["setRoutes"])
  },
  mounted() {
    this.setRoutes(this.routes);
  }
};
</script>
